<template>
    <div class="content">
        <div class="upload">
            <div style="height: 100%">
                <UploadBox
                    :selectData="selectData"
                    :config="configData"
                    :tableColumn="tableColumn"
                    :currentKey="currentKey"
                     @update="handleUpdate"
                />
            </div>
        </div>
        <div class="btns tar">
            <el-button @click="()=>$emit('close')">取消</el-button>
            <el-button type="primary" @click="handleSubmit">应用</el-button>
        </div>
    </div>
</template>

<script>
import UploadBox from '../components/uploadIdea/uploadBox.vue'
import {  cloneDeep } from 'lodash'
const VIDEO_KEY='视频',IMAGE_KEY='图片'
export default {
    components: { UploadBox },
    props: [ 'config', 'cbs', 'groups', 'appName', 'appList', 'searchConfigData' ],
    provide() {
        const appName = this.appName
        return {
            showPage:()=>true,
            getAppList: ()=>this.appList,
            hasAll: true,
            keyWords: appName,
            ideaGlobal: this
        }
    },
    data() {
        return {
            currentKey: 'key',
            selectData: {},
            tableColumn: [
                {
                    explicit_name: VIDEO_KEY,
                },
                {
                    explicit_name: IMAGE_KEY,
                }
            ]
        }
    },
    computed: {
        configData() {
            return this.config.map(v=> {
                return {
                    ...v,
                    explicit_name: v.material_type === '1'? '图片':'视频'
                }
            }).sort((b, a)=> {
                return a.material_type - b.material_type
            })
        },

    },
    methods: {
         handleSubmit() {
            const selectData = this.selectData[this.currentKey];
            if (!(selectData&&selectData.length)) {
                this.$message.error('请选择需要应用的素材')
                return;
            }
            const { videoList, imageList } = selectData.reduce((pre, item)=> {
                if (item[VIDEO_KEY]) {
                    pre.videoList.push(item[VIDEO_KEY])
                }
                if (item[IMAGE_KEY]) {
                    pre.imageList.push(item[IMAGE_KEY])
                };
                return pre;
            }, {
                videoList: [],
                imageList: []
            });
            const list = [
                // {
                //     value: {},
                //     to: []
                // }
            ];
            videoList.forEach(v=> {
                const data = {
                    value: v,
                    to: []
                }
                list.push(data);
                const vConfigList = this.config.filter(v=>v.material_type === '3');
                const { size, duration, width, height } = v
                vConfigList.forEach((config)=> {
                    const { conf_size, conf_resolution, conf_length } = config
                    // 验证宽高
                    if (`${width}*${height}` !== conf_resolution) {
                        return
                    }
                    // 验证大小
                    if (+duration > +conf_length) {
                        return
                    }
                    if (+size > +conf_size) {
                        return
                    };
                    data.to.push(config)
                })

            });
            imageList.forEach(v=> {
                const data = {
                    value: v,
                    to: []
                }
                list.push(data);
                const iConfigList = this.config.filter(v=>v.material_type === '1');
                const { size, width, height } = v
                iConfigList.forEach((config)=> {
                    const { conf_size, conf_resolution } = config
                    // 验证宽高
                    if (`${width}*${height}` !== conf_resolution) {
                        return
                    }
                    // 验证大小
                    if (+size > +conf_size) {
                        return
                    };
                    data.to.push(config)
                });
            });
            // this.groups
            this.cbs.onSubmit(list)
        },
        handleUpdate(list) {
            this.selectData = {
                [this.currentKey]: cloneDeep(list)
            };
            console.log(this.selectData, 'selectData');
            console.log(this.config, 'config');
            console.log(this.groups, 'config');
        },
    }
}
</script>

<style lang="scss" scoped>
.content {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .btns {
        height: 60px;
        line-height: 60px;
        padding-right: 50px;
        // border-top: 1px solid #ccc;
    }
}
 .upload {
        flex: 1;
        height: 0;
    }
</style>
